import { setAuthSessionItem } from "utils/authSession";
import { formatAbn } from "utils/abn";
import BusinessEligibilityProfile from "components/BusinessEligibilityProfile";
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";

// prop-types is a library for typechecking of props.

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React base styles

// Images
import backgroundImage from "assets/images/bg-profile.jpg";

// @mui material components

import { FormControl, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MuiPhoneNumber from "material-ui-phone-number";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getUserProfileByID } from "utils/api";
import { appConstants } from "utils/appConstants";
// Material Dashboard 2 React components

function MyProfile({ children }) {
  const dispatch = useDispatch();
  const [imgError, setImgError] = useState(false);

  const initialUser = React.useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("LOGIN_DETAILS") || "{}");
    } catch {
      return {};
    }
  }, []);

  const masterUserType = initialUser.userType || "Business";

  const [values, setValues] = React.useState({
    firstName: initialUser.firstName || "",
    lastName: initialUser.lastName || "",
    emailAddress: initialUser.emailAddress || initialUser.email || "",
    phoneNumber: initialUser.phoneNumber || "",
    businessUserPhoneNumber: initialUser.businessUserPhoneNumber || "",
    businessUserEmailAddress: initialUser.businessUserEmailAddress || "",
    stateName: initialUser.stateName || "",
    countryName: initialUser.countryName || "",
    zipCode: initialUser.zipCode || "",
    streetAddress:
      initialUser.companyStreetAddress || initialUser.streetAddress || "",
    companyName: initialUser.companyName || initialUser.businessName || "",
    city: initialUser.companyCity || initialUser.city || "",
    _id: initialUser._id || "",
    isChildUser: initialUser.isChildUser || false,
    profilePictureFileName:
      initialUser.profilePictureFileName ||
      initialUser.profilePicFileName ||
      "",
    profileImage: initialUser.profileImage || "",
    ...initialUser,
  });

  const resolveProfileImageUrl = React.useCallback((userObj) => {
    const raw =
      userObj?.profilePictureFileName ||
      userObj?.profilePicFileName ||
      userObj?.profileImage ||
      userObj?.avatar ||
      userObj?.photo;
    if (!raw || typeof raw !== "string" || !raw.trim()) return "";
    const trimmed = raw.trim();
    if (trimmed === "null" || trimmed === "undefined" || trimmed === "empty")
      return "";
    if (
      trimmed.startsWith("http://") ||
      trimmed.startsWith("https://") ||
      trimmed.startsWith("data:") ||
      trimmed.startsWith("blob:")
    ) {
      return trimmed;
    }
    return `${appConstants.baseURL}user/viewFile?fileName=${encodeURIComponent(
      trimmed
    )}`;
  }, []);

  const userId = React.useMemo(() => {
    const rawUserId = sessionStorage.getItem("USER_ID");
    const parsedId =
      rawUserId && rawUserId !== "null" && rawUserId !== "undefined"
        ? rawUserId.replace(/["']/g, "").trim()
        : null;
    return parsedId || initialUser._id;
  }, [initialUser._id]);

  useEffect(() => {
    if (userId) {
      getUserProfileByID(
        { _id: userId },
        (data) => {
          if (data?.Result_Output?.length > 0) {
            const fetchedUserProfile = data.Result_Output[0];
            setValues((prev) => ({
              ...prev,
              ...fetchedUserProfile,
              profilePictureFileName:
                fetchedUserProfile.profilePictureFileName ||
                prev.profilePictureFileName ||
                "",
            }));
            setImgError(false);
            if (fetchedUserProfile) {
              try {
                const currentSession = JSON.parse(
                  sessionStorage.getItem("LOGIN_DETAILS") || "{}"
                );
                setAuthSessionItem(
                  "LOGIN_DETAILS",
                  JSON.stringify({ ...currentSession, ...fetchedUserProfile })
                );
                window.dispatchEvent(new Event("user-profile-updated"));
              } catch {}
            }
          }
        },
        dispatch
      );
    }
  }, [userId, dispatch]);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox position="relative" mb={5}>
          <MDBox
            display="flex"
            alignItems="center"
            position="relative"
            minHeight="18.75rem"
            borderRadius="xl"
            sx={{
              backgroundImage: ({
                functions: { rgba, linearGradient },
                palette: { gradients },
              }) =>
                `${linearGradient(
                  rgba(gradients.info.main, 0.6),
                  rgba(gradients.info.state, 0.6)
                )}, url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "50%",
              overflow: "hidden",
            }}
          />
          <Card
            sx={{
              position: "relative",
              mt: -8,
              mx: 3,
              py: 5,
              px: 2,
            }}
          >
            <Grid container spacing={3} pl={3} alignItems="center">
              <Grid item>
                <MDAvatar
                  src={
                    !imgError && resolveProfileImageUrl(values)
                      ? resolveProfileImageUrl(values)
                      : undefined
                  }
                  onError={() => setImgError(true)}
                  imgProps={{ crossOrigin: "anonymous" }}
                  alt={
                    `${values.firstName || ""} ${
                      values.lastName || ""
                    }`.trim() || "profile-image"
                  }
                  size="xl"
                  shadow="sm"
                  sx={{
                    bgcolor: "var(--interactive-soft, #f0f8f7)",
                    color: "var(--interactive-default, #0f766e)",
                    fontWeight: 600,
                    fontSize: "1.25rem",
                    border: "2px solid var(--border-subtle, #dce3e2)",
                  }}
                >
                  {(
                    `${values.firstName || ""} ${
                      values.lastName || ""
                    }`.trim() ||
                    values.companyName ||
                    "IR"
                  )
                    .split(/\s+/)
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((p) => p[0])
                    .join("")
                    .toUpperCase()}
                </MDAvatar>
              </Grid>
              <Grid item>
                <MDBox height="100%" mt={0.5} lineHeight={1}>
                  <MDTypography variant="h5" fontWeight="medium">
                    {values.firstName + " " + values.lastName}
                  </MDTypography>
                  <MDTypography
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    {/* CEO / Co-Founder */}
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <Card sx={{ boxShadow: "none", px: 3 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={12} xl={12} lg={12}>
                  <MDBox p={2} px={0}>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      textTransform="capitalize"
                    >
                      My Profile
                    </MDTypography>
                  </MDBox>
                </Grid>
              </Grid>
              <Grid container columnSpacing={4} rowSpacing={2}>
                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    type="text"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    value={values.firstName}
                    // onChange={handleChange("firstName")}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    type="text"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    value={values.lastName}
                    // onChange={handleChange("lastName")}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    type="email"
                    label="Email Address (Username)"
                    variant="outlined"
                    fullWidth
                    value={values.emailAddress}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <MuiPhoneNumber
                    onlyCountries={["in", "au"]}
                    defaultCountry={"au"}
                    type="text"
                    label="Mobile Number"
                    variant="outlined"
                    fullWidth
                    value={values.phoneNumber}
                    // onChange={(phone, country) => setPhoneValues(phone, country)}
                    disabled
                  />
                </Grid>
                {masterUserType === "Business" && (
                  <>
                    {values.isUserChild && (
                      <Grid container spacing={1}>
                        <Grid item xs={12} md={12} xl={12} lg={12}>
                          <MDBox p={2} px={4}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              textTransform="capitalize"
                            >
                              Business Profile
                            </MDTypography>
                          </MDBox>
                        </Grid>
                      </Grid>
                    )}
                    <Grid item xs={12} md={6} lg={3}>
                      <TextField
                        type="text"
                        label="Business Name"
                        variant="outlined"
                        fullWidth
                        value={values.companyName}
                        disabled
                      />
                    </Grid>
                    {masterUserType === "Business" && values.isUserChild && (
                      <>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="email"
                            label="Email Address"
                            variant="outlined"
                            inputProps={{
                              pattern: "^[a-zA-Z@. ]+$",
                              maxLength: 30,
                            }}
                            fullWidth
                            value={values.businessUserEmailAddress}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <MuiPhoneNumber
                            onlyCountries={["in", "au"]}
                            defaultCountry={"au"}
                            type="text"
                            label="Mobile Number"
                            variant="outlined"
                            fullWidth
                            value={values.businessUserPhoneNumber}
                            disabled
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} md={6} lg={3}>
                      <TextField
                        type="text"
                        label="Street Address"
                        variant="outlined"
                        fullWidth
                        value={values.streetAddress}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <TextField
                        type="text"
                        label="City"
                        variant="outlined"
                        fullWidth
                        value={values.city}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <TextField
                        type="text"
                        label="Zip Code"
                        variant="outlined"
                        fullWidth
                        value={values.zipCode}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                      <TextField
                        type="text"
                        label="Country"
                        variant="outlined"
                        fullWidth
                        value={values.countryName}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <TextField
                        type="text"
                        label="State"
                        variant="outlined"
                        fullWidth
                        value={values.stateName}
                        disabled
                      />
                    </Grid>
                  </>
                )}

                {values.userType !== "Admin" && (
                  <>
                    <Grid item xs={12} md={6} lg={3}>
                      <FormControl fullWidth>
                        <TextField
                          type="text"
                          label="Organization Type"
                          InputLabelProps={{ shrink: true }}
                          variant="outlined"
                          fullWidth
                          value={values.organizationType}
                          disabled
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <TextField
                        type="text"
                        label="Industry Type"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        value={values.industryType}
                        disabled
                      />
                    </Grid>
                    {values.userType !== "Business" && (
                    <Grid item xs={12} md={6} lg={3}>
                      <TextField
                        type="text"
                        label="ABN Number"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={formatAbn(values.abnNumber)}
                        disabled
                      />
                    </Grid>
                    )}
                  </>
                )}
              </Grid>

              {values.userType === "Business" && <BusinessEligibilityProfile business={values} onSaved={patch => setValues(current => ({ ...current, ...patch }))} />}

              <Grid
                container
                mt={2}
                columnSpacing={4}
                alignItems="center"
                display="flex"
                justifyContent="center"
              >
                <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                  <Link to={"/editprofile"}>
                    <MDButton
                      className="btn-block center-container-btn btn-warning btn-back rightSpace"
                      color="success"
                      fullWidth
                      // style={{ width: "90px" }}
                    >
                      Edit
                    </MDButton>
                  </Link>
                </Grid>
              </Grid>
            </Card>
          </Card>
        </MDBox>
      </DashboardLayout>
    </>
  );
}

// Setting default props for the Header

export default MyProfile;
